/**
 * 탭 진입 시 시작할 튜토리얼 시나리오를 결정하는 순수 함수.
 *
 * 정책: "각 탭 첫 진입 시 항상" — 메인 튜토리얼 완료 여부와 무관하게, 각 탭에 처음 들어가면
 * 그 탭의 튜토리얼(`scenarioId = TabId` 컨벤션)을 시작한다. 단 (a) 다른 튜토리얼이 표시 중이면
 * 보류(겹침 방지), (b) 시나리오가 없는 탭(battle 등)은 제외, (c) 이미 완료한 탭은 재표시 안 함.
 *
 * 결정만 하고 부수효과(startScenario 호출)는 호출자(GameScene onTabEntered)가 수행한다.
 * completed/hasScenario 게이트는 `TutorialRunner.startScenario`의 자동 스킵과 이중 안전망이다.
 */
import type { TabId } from "../ui/tabVisibility.js";

export interface ResolveTabTutorialStartArgs {
  /** 진입한 탭. */
  readonly tab: TabId;
  /** 완료한 시나리오 id 목록 (SaveData.tutorialCompleted). */
  readonly completed: readonly string[];
  /** 시나리오 보유 여부 (스텝 ≥1) — TutorialRunner.hasScenario 위임. */
  readonly hasScenario: (scenarioId: string) => boolean;
  /** 다른 튜토리얼이 현재 표시 중인지 — 표시 중이면 보류. */
  readonly tutorialActive: boolean;
}

/**
 * @returns 시작할 scenarioId(= tab). 시작하지 않으면 null.
 */
export function resolveTabTutorialStart(args: ResolveTabTutorialStartArgs): string | null {
  const { tab, completed, hasScenario, tutorialActive } = args;
  if (tutorialActive) return null; // 다른 튜토리얼 표시 중 — 겹침 방지
  if (tab === "battle") return null; // 메인(전투) 탭은 부팅 시 main 시나리오로 별도 처리
  if (!hasScenario(tab)) return null; // 시나리오 미정의 탭
  if (completed.includes(tab)) return null; // 이미 본 탭 — 재진입 시 안 뜸
  return tab;
}
